import { IconCheck } from 'ui-icons';

import { ImageMantine, Indicator } from '../../../../DataDisplay';
import { Box } from '../../../../Miscellaneous/Box';
import star from './assets/star.svg';

type CompletedIndicatorProps = {
  completed?: boolean;
  children: React.ReactNode;
};

const IndicatorLabel = () => {
  return (
    <Box pos="relative">
      <ImageMantine src={star} w={42} />
      <IconCheck
        color="white"
        style={{
          filter: 'drop-shadow(0px 2px 12px #836100)',
          position: 'absolute',
          top: '9px',
          left: '9px',
        }}
      />
    </Box>
  );
};

const CompletedIndicator = ({ completed, children }: CompletedIndicatorProps) => {
  return (
    <Indicator
      disabled={!completed}
      color="transparent"
      label={<IndicatorLabel />}
      position="top-end"
      offset={11}
    >
      {children}
    </Indicator>
  );
};

export { CompletedIndicator };
